export default __webpack_public_path__ + "static/media/basketball.38e3d990.svg";